export enum QueryOperator {
  And = 0,
  Or = 1,
}
